<template>
  <el-card style="border-radius: 8px;margin-bottom: 40px;">
    <div @mouseenter="mouseOver($event)"
         @click="toDetail">
      <div class="image">
        <img :src="item.imageUrl">
      </div>
      <div style="padding: 14px;">
        <div>
          <span class="card-detail-info-title">{{ item.name }}</span>
        </div>
        <div style="margin-top: 10px">
          <span style="font-size: 14px;color: #666666">学时：{{ item.hours }}</span>
          <!--<span style="float: right; font-size: 16px;color: #FF0000"> ￥{{item.price}}</span>-->
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "Cart",
  props: {
    item: {},
  },
  data() {
    return {
      isHaveCourse: true
    }
  },
  methods: {
    mouseOver(event) {
      event.currentTarget.style.cursor = 'pointer'
    },
    // 判断是否拥有该课程
    async isHave(courseId) {
      const {content} = await this.$http.get('/business/web/userCourse/isBuyCourse', {params: {courseId}});
      this.isHaveCourse = content;
    },
    async toDetail() {
      await this.isHave(this.item.id)
      if (this.isHaveCourse) {
        const params = {
          courseId: this.item.id
        };
        let routerName = '';
        if (this.item.courseType === 'O') {
          routerName = 'TrainDetail';
        } else if (this.item.courseType === 'C') {
          routerName = 'EduDetail';
        }
        let routeUrl = this.$router.resolve({name: routerName, params: params});
        window.open(routeUrl.href, '_blank');
      } else {
        this.$message.error('非本学习班课程!');
      }
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.image {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 75%; /*padding-bottom都可以*/
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.el-card > > > .el-card__body {
  padding: 0;
}

.el-card {
  transition: transform 0.3s ease-out;

  &:hover {
    transform: translateY(-8px);
  }
}

.card-detail-info-title {
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
